import React, { useState } from "react";
import Select from "react-select";
import { Plus, Trash2, Edit } from "lucide-react";
import TagInput from "../TagInput";
import ReportSectionInput from "./ReportSectionInput";
import { URL_PATTERN } from '../../../../constants/Dashboard';
import { ChevronDown } from "lucide-react";
import { Upload } from "lucide-react";
import UploadExcel from "./UploadExcel";


const OnboardProductFormSections = ({
  formConfig,
  formData,
  setFormData,
  productNameOptions,
  selectedProductName,
  handleProductNameSelect,
  handleProductCodeSelect,
  isLoadingCodes,
  isLoadingDetails,
  isSubmitting,
  regionsCountriesData,
  parentRegionOptions,
  reportTypes,
  selectedParentRegions,
  handleParentRegionChange,
  regionOptions,
  selectedRegions,
  handleRegionChange,
  countryOptions,
  handleCountryChange,
  selectedDomain,
  handleDomainChange,
  selectedSubDomain,
  handleSubdomainChange,
  selectedSubSubDomain,
  handleSubSubdomainChange,
  subdomainOptions,
  subSubdomainOptions,
  domainData,
  isDomainEditMode,
  setIsDomainEditMode,
  isMarketEditMode,
  setIsMarketEditMode,
  addCostPeriod,
  removeCostPeriod,
  updateCostPeriod,
  ALLOWED_EMAIL_DOMAINS,
  isProductOwnerEmailValid,
  isEditMode,
  openSections,   
  toggleSection,
  sethasUploaded,
  selectedFile,
  setSelectedFile
}) => {

  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [isUploadHovered, setIsUploadHovered] = useState(false);

  const hasProductOwnerEmail =
    formData.productOwner && formData.productOwner.trim() !== "";

  const renderCostField = (costType) => {
    const periods = formData[costType.name] || [];

    return (
      <div key={costType.name}>
        <div className="flex items-center justify-between mb-2 font-bold">
          <div>{costType.label}</div>
          <button
            type="button"
            onClick={() => addCostPeriod(costType.name)}
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-[#bb1ccc] hover:text-[#000080] transition-colors"
            disabled={isSubmitting}
          >
            <Plus className="h-4 w-4" />
            <span>Add Row</span>
          </button>
        </div>

        {periods.map((period) => {
          const currentPeriod = formData[costType.name].find(
            (p) => p.id === period.id
          );

          return (
            <div key={period.id} className="flex items-center space-x-4 mb-4">
              <div className="flex flex-col">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Cost
                </label>
                <input
                  type="number"
                  required
                  value={
                    period.cost === undefined || period.cost === null
                      ? ""
                      : period.cost
                  }
                  onChange={(e) =>
                    updateCostPeriod(
                      costType.name,
                      period.id,
                      "cost",
                      e.target.value === "" ? "" : Number(e.target.value)
                    )
                  }
                  className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                  placeholder="Enter cost in $"
                  disabled={isSubmitting}
                  min="0"
                />
              </div>

              {period.cost > 0 && (
                <>
                  <div className="flex flex-col">
                    <label className="text-sm text-gray-600 mb-1">
                      Start Date
                    </label>
                    <input
                      type="date"
                      required
                      value={period.startDate || ""}
                      onChange={(e) => {
                        const newStartDate = e.target.value;
                        updateCostPeriod(
                          costType.name,
                          period.id,
                          "startDate",
                          newStartDate
                        );
                        if (
                          period.endDate &&
                          new Date(period.endDate) <= new Date(newStartDate)
                        ) {
                          updateCostPeriod(
                            costType.name,
                            period.id,
                            "endDate",
                            ""
                          );
                        }
                      }}
                      className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-sm text-gray-600 mb-1">
                      End Date
                    </label>
                    <input
                      type="date"
                      required
                      value={period.endDate || ""}
                      min={currentPeriod?.startDate || undefined}
                      onChange={(e) =>
                        updateCostPeriod(
                          costType.name,
                          period.id,
                          "endDate",
                          e.target.value
                        )
                      }
                      className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
                      disabled={isSubmitting}
                    />
                  </div>
                </>
              )}

              <button
                type="button"
                onClick={() => removeCostPeriod(costType.name, period.id)}
                className="text-[#bb1ccc] hover:text-[#000080] mt-[15px]"
                disabled={isSubmitting}
              >
                <Trash2 className="h-8 w-8" />
              </button>
            </div>
          );
        })}
      </div>
    );
  };

  const renderField = (field) => {
    const commonProps = {
      required: field.required,
      value: formData[field.name],
      onChange:
        field.name === "productCode"
          ? handleProductCodeSelect
          : (e) =>
            setFormData({
              ...formData,
              [field.name]: e.target.value,
            }),
      className: `w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500 ${(field.name === "productCode" && isLoadingCodes) ||
          (isLoadingDetails &&
            [
              "productName",
              "description",
              "dataLayer",
              "domain",
              "subDomain",
              "productOwner",
            ].includes(field.name)) ||
          (field.name === "marketRegion" && isLoadingCodes)
          ? "opacity-50 cursor-not-allowed"
          : ""
        }`,
      placeholder: field.placeholder,
      disabled:
        isSubmitting ||
        (field.name === "productCode" && isLoadingCodes) ||
        (isLoadingDetails &&
          [
            "productName",
            "description",
            "dataLayer",
            "domain",
            "subDomain",
            "productOwner",
          ].includes(field.name)) ||
        (field.name === "marketRegion" && isLoadingCodes),
    };

    switch (field.type) {
      case "select":
        if (field.name === "marketRegion") {
          return (
            <Select
              isMulti
              name={field.name}
              options={regionsCountriesData.map((r) => ({
                value: r.region,
                label: r.region,
              }))}
              value={selectedRegions}
              onChange={handleRegionChange}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder={commonProps.placeholder}
              isDisabled={commonProps.disabled}
              required={commonProps.required}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? "#bb1ccc" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 2px #bb1ccc" : base.boxShadow,
                }),
              }}
            />
          );
        }
        if (field.name === "marketCountry") {
          return (
            <Select
              isMulti
              name={field.name}
              options={countryOptions}
              value={countryOptions.filter((option) =>
                (formData.marketCountry || []).includes(option.value)
              )}
              onChange={handleCountryChange}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder={commonProps.placeholder}
              isDisabled={commonProps.disabled || selectedRegions.length === 0}
              required={commonProps.required}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? "#bb1ccc" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 2px #bb1ccc" : base.boxShadow,
                }),
              }}
            />
          );
        }
        if (field.name === "reportType") {
          return (
            <Select
              name={field.name}
              options={reportTypes}
              value={
                reportTypes.find(
                  (option) => option.value === (
                    Array.isArray(formData[field.name]) && formData[field.name].length > 0
                      ? formData[field.name][0].value
                      : formData[field.name]?.value
                  )
                ) || null
              }
              onChange={(selectedOption) => {
                setFormData({
                  ...formData,
                  [field.name]: selectedOption ? [selectedOption] : [],
                });
              }}
              className="basic-single-select"
              classNamePrefix="select"
              placeholder={commonProps.placeholder}
              isDisabled={commonProps.disabled}
              required={commonProps.required}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? "#bb1ccc" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 2px #bb1ccc" : base.boxShadow,
                }),
              }}
            />
          );
        }
        return (
          <Select
            name={field.name}
            options={field.options}
            value={
              field.options.find(
                (option) => option.value === formData[field.name]
              ) || null
            }
            onChange={(selectedOption) => {
              setFormData({
                ...formData,
                [field.name]: selectedOption ? selectedOption.value : "",
              });
            }}
            className="basic-single-select"
            classNamePrefix="select"
            placeholder={commonProps.placeholder}
            isDisabled={commonProps.disabled}
            required={commonProps.required}
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: state.isFocused ? "#bb1ccc" : base.borderColor,
                boxShadow: state.isFocused ? "0 0 0 2px #bb1ccc" : base.boxShadow,
              }),
            }}
          />
        );
      case "multiselect":
        return (
          <Select
            isMulti
            name={field.name}
            options={field.options}
            value={formData[field.name]}
            onChange={(selectedOptions) => {
              setFormData({
                ...formData,
                [field.name]: selectedOptions || [],
              });
            }}
            className="basic-multi-select"
            classNamePrefix="select"
            placeholder="Select options..."
            isDisabled={isSubmitting}
            required={field.required}
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: state.isFocused ? "#bb1ccc" : base.borderColor,
                boxShadow: state.isFocused ? "0 0 0 2px #bb1ccc" : base.boxShadow,
              }),
            }}
          />
        );
      case "textarea":
        const isDescriptionField = field.name === "description";
        const isReportLinkField = field.name === "reportLink";
        const currentLength = formData[field.name]?.length || 0;
        const maxLength = 10000;
        const isOverLimit = currentLength > maxLength;
        const isNearLimit = currentLength > maxLength * 0.9;

        // URL validation for reportLink (supports multiple URLs separated by commas)
        const hasReportLinkValue = isReportLinkField && formData[field.name]?.trim();

        let isValidURL = true;
        let invalidUrls = [];

        if (hasReportLinkValue) {
          // Split by comma and validate each URL
          const urls = formData[field.name].split(',').map(url => url.trim()).filter(url => url.length > 0);

          urls.forEach(url => {
            if (!URL_PATTERN.test(url)) {
              isValidURL = false;
              invalidUrls.push(url);
            }
          });
        }

        return (
          <div>
            <textarea
              {...commonProps}
              rows={isReportLinkField ? 2 : 3}
              maxLength={maxLength}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= maxLength) {
                  setFormData({ ...formData, [field.name]: value });
                }
              }}
              className={`w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 ${isReportLinkField && hasReportLinkValue && !isValidURL
                  ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                  : isOverLimit
                    ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                    : isNearLimit
                      ? "border-orange-400 focus:ring-orange-400 focus:border-orange-400"
                      : "border-gray-300 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
                }`}
            />

            {/* URL validation error for reportLink ONLY */}
            {isReportLinkField && hasReportLinkValue && !isValidURL && (
              <div className="mt-1">
                <p className="text-sm text-red-600 font-medium">
                  Invalid URL(s) found. Please check the following:
                </p>
                <ul className="text-sm text-red-600 ml-4 mt-1 list-disc">
                  {invalidUrls.slice(0, 3).map((url, index) => (
                    <li key={index}>{url}</li>
                  ))}
                  {invalidUrls.length > 3 && (
                    <li>... and {invalidUrls.length - 3} more</li>
                  )}
                </ul>

              </div>
            )}

            {/* Helper text for reportLink ONLY when valid or empty */}
            {isReportLinkField && !hasReportLinkValue && (
              <p className="mt-1 text-xs text-gray-500">
                You can add multiple URLs separated by commas
              </p>
            )}

            {/* Character count for description ONLY */}
            {isDescriptionField && (
              <div className="mt-1 flex justify-between items-center">
                <span
                  className={`text-sm font-medium ${isOverLimit
                      ? "text-red-600"
                      : isNearLimit
                        ? "text-orange-600"
                        : "text-gray-500"
                    }`}
                >
                  {currentLength}/{maxLength} characters
                </span>
                {isOverLimit && (
                  <span className="text-sm text-red-600 font-semibold bg-red-50 px-2 py-1 rounded">
                    ⚠️ You can't enter more than 10000 characters
                  </span>
                )}
                {isNearLimit && !isOverLimit && (
                  <span className="text-sm text-orange-600 font-medium">
                    ⚠️ Approaching character limit
                  </span>
                )}
              </div>
            )}
          </div>
        );
      case "numberWithUnit":
        return (
          <div className="flex gap-4">
            <div className="flex-1">
              <input
                type="number"
                {...commonProps}
                value={
                  formData[field.name] !== undefined &&
                    formData[field.name] !== null
                    ? formData[field.name]
                    : ""
                }
                onChange={(e) => {
                  const value =
                    e.target.value === "" ? "" : parseInt(e.target.value, 10);
                  setFormData({ ...formData, [field.name]: value });
                }}
                placeholder="Enter size"
                min="0"
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
              />
            </div>
            <div className="w-32">
              <select
                {...commonProps}
                value={formData[`${field.name}Unit`] || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    [`${field.name}Unit`]: e.target.value,
                  })
                }
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
              >
                <option value="">Unit</option>
                {field.unitOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        );
      case "tagInput":
        return (
          <TagInput
            field={field}
            formData={formData}
            setFormData={setFormData}
            isSubmitting={isSubmitting}
          />
        );
      case "reportSectionInput":
        return (
          <ReportSectionInput
            field={field}
            formData={formData}
            setFormData={setFormData}
            isSubmitting={isSubmitting}
          />
        );
     
    case "number":
  return (
<input
      type="number"
      {...commonProps}
      min="0"
      onChange={(e) => {
        const value = e.target.value === "" ? "" : Number(e.target.value);
        setFormData({
          ...formData,
          [field.name]: value !== "" ? Math.max(0, value) : value,
        });
      }}
      className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
    />
  );
      default:
        return (
          <input
            type={field.type || "text"}
            {...commonProps}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
          />
        );
    }
  };

  const renderProductNameField = () => {
    if (isEditMode) {
      return (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Product Name
          </label>
          <input
            type="text"
            value={formData.productName || ""}
            disabled
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-gray-100 placeholder-gray-500"
            placeholder="Product name"
          />
        </div>
      );
    }

    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Product Name
        </label>
        <Select
          options={productNameOptions}
          value={
            productNameOptions.find(
              (option) => option.value === selectedProductName
            ) || null
          }
          onChange={handleProductNameSelect}
          placeholder="Select product name"
          isDisabled={isLoadingCodes}
          isLoading={isLoadingCodes}
          className="basic-single-select"
          classNamePrefix="select"
          styles={{
            control: (base, state) => ({
              ...base,
              borderColor: state.isFocused ? "#bb1ccc" : base.borderColor,
              boxShadow: state.isFocused ? "0 0 0 2px #bb1ccc" : base.boxShadow,
            }),
          }}
        />
      </div>
    );
  };

  const renderProductCodeField = () => (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Product Code
      </label>
      <input
        type="text"
        value={formData.productCode}
        onChange={(e) =>
          setFormData({ ...formData, productCode: e.target.value })
        }
        placeholder="Enter product code"
        className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-gray-100 placeholder-gray-500"
        disabled
        required
      />
    </div>
  );

  const renderProductOwnerField = () => {
    const isEmailInvalid = hasProductOwnerEmail && !isProductOwnerEmailValid;

    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Product Owner
        </label>
        <input
          type="email"
          value={formData.productOwner || ""}
          onChange={(e) =>
            setFormData({ ...formData, productOwner: e.target.value })
          }
          className={`w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 bg-white placeholder-gray-500 ${isEmailInvalid
              ? "border-red-500 focus:ring-red-500 focus:border-red-500"
              : "border-gray-300 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
            }`}
          disabled={isSubmitting}
          placeholder={`Enter product owner email (${ALLOWED_EMAIL_DOMAINS.map(
            (d) => `@${d}`
          ).join(", ")})`}
          required
        />
        {isEmailInvalid && (
          <p className="mt-1 text-sm text-red-600">
            Please enter a valid email address from:{" "}
            {ALLOWED_EMAIL_DOMAINS.join(", ")}
          </p>
        )}
      </div>
    );
  };

  const renderReportOwnerField = () => {
    const reportOwnerEmail = formData.reportOwner || "";
    const hasReportOwnerEmail = reportOwnerEmail.trim() !== "";
    const isReportOwnerEmailValid = hasReportOwnerEmail &&
      reportOwnerEmail.toLowerCase().endsWith("@effem.com");
    const isEmailInvalid = hasReportOwnerEmail && !isReportOwnerEmailValid;

    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Report Owner
        </label>
        <input
          type="email"
          value={reportOwnerEmail}
          onChange={(e) =>
            setFormData({ ...formData, reportOwner: e.target.value })
          }
          className={`w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 bg-white placeholder-gray-500 ${isEmailInvalid
              ? "border-red-500 focus:ring-red-500 focus:border-red-500"
              : "border-gray-300 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
            }`}
          disabled={isSubmitting}
          placeholder="Enter report owner email "
          required
        />
        {isEmailInvalid && (
          <p className="mt-1 text-sm text-red-600">
            Please enter a valid email address ending with @effem.com
          </p>
        )}
      </div>
    );
  };

  const renderDomainField = () => {
    const domainField = formConfig.basicInformation.fields.find(
      (f) => f.name === "domain"
    );

    return (
      <div className="form-group">
        <label>{domainField.label}</label>
        <div className="flex items-center gap-2">
          {!isDomainEditMode ? (
            <>
              <input
                type="text"
                readOnly
                value={formData.domain || ""}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                placeholder="Select domain"
              />
              <button
                type="button"
                onClick={() => setIsDomainEditMode(true)}
                className="text-[#bb1ccc] hover:text-[#000080] p-2"
              >
                <Edit size={16} />
              </button>
            </>
          ) : (
            <Select
              value={selectedDomain}
              onChange={handleDomainChange}
              options={domainData.map((d) => ({
                value: d.parent_domain_id,
                label: d.parent_domain,
              }))}
              placeholder={domainField.placeholder}
              className="basic-single-select w-full"
              classNamePrefix="select"
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? "#bb1ccc" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 2px #bb1ccc" : base.boxShadow,
                }),
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const renderSubdomainField = () => {
    const subdomainField = formConfig.basicInformation.fields.find(
      (f) => f.name === "subDomain"
    );

    return (
      <div className="form-group">
        <label>{subdomainField.label}</label>
        <div className="flex items-center gap-2">
          {!isDomainEditMode ? (
            <>
              <input
                type="text"
                readOnly
                value={formData.subDomain}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                placeholder="Select sub domain"
              />
              <button
                type="button"
                onClick={() => setIsDomainEditMode(true)}
                className="text-[#bb1ccc] hover:text-[#000080] p-2"
              >
                <Edit size={16} />
              </button>
            </>
          ) : (
            <Select
              value={selectedSubDomain}
              onChange={handleSubdomainChange}
              options={subdomainOptions}
              placeholder={subdomainField.placeholder}
              isDisabled={!selectedDomain}
              className="basic-single-select w-full"
              classNamePrefix="select"
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? "#bb1ccc" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 2px #bb1ccc" : base.boxShadow,
                }),
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const renderSubSubdomainField = () => {
    const subSubdomainField = formConfig.basicInformation.fields.find(
      (f) => f.name === "subSubDomain"
    );

    return (
      <div className="form-group">
        <label>{subSubdomainField.label}</label>
        <div className="flex items-center gap-2">
          {!isDomainEditMode ? (
            <>
              <input
                type="text"
                readOnly
                value={formData.subSubDomain}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                placeholder="Select sub sub domain"
              />
              <button
                type="button"
                onClick={() => setIsDomainEditMode(true)}
                className="text-[#bb1ccc] hover:text-[#000080] p-2"
              >
                <Edit size={16} />
              </button>
            </>
          ) : (
            <Select
              value={selectedSubSubDomain}
              onChange={handleSubSubdomainChange}
              options={subSubdomainOptions}
              placeholder={subSubdomainField.placeholder}
              isDisabled={!selectedSubDomain}
              className="basic-single-select w-full"
              classNamePrefix="select"
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? "#bb1ccc" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 2px #bb1ccc" : base.boxShadow,
                }),
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const renderParentRegionField = () => {
    const parentRegionField = formConfig.marketInformation.fields.find(
      (f) => f.name === "parentRegions"
    );

    if (!parentRegionField) return null;

    return (
      <div className="form-group">
        <label>{parentRegionField.label}</label>
        <div className="flex items-center gap-2">
          {!isMarketEditMode ? (
            <>
              <input
                type="text"
                readOnly
                value={
                  Array.isArray(formData.parentRegions)
                    ? formData.parentRegions.join(", ")
                    : formData.parentRegions || ""
                }
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                placeholder="Select parent region"
              />
              <button
                type="button"
                onClick={() => setIsMarketEditMode(true)}
                className="text-[#bb1ccc] hover:text-[#000080] p-2"
              >
                <Edit size={16} />
              </button>
            </>
          ) : (
            <Select
              isMulti
              name="parentRegions"
              options={parentRegionOptions}
              value={selectedParentRegions}
              onChange={handleParentRegionChange}
              className="basic-multi-select w-full"
              classNamePrefix="select"
              placeholder={parentRegionField.placeholder}
              isDisabled={isLoadingCodes}
              required={parentRegionField.required}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? "#bb1ccc" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 2px #bb1ccc" : base.boxShadow,
                }),
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const renderMarketRegionField = () => {
    const marketRegionField = formConfig.marketInformation.fields.find(
      (f) => f.name === "marketRegion"
    );

    return (
      <div className="form-group">
        <label>{marketRegionField.label}</label>
        <div className="flex items-center gap-2">
          {!isMarketEditMode ? (
            <>
              <input
                type="text"
                readOnly
                value={
                  Array.isArray(formData.marketRegion)
                    ? formData.marketRegion.join(", ")
                    : formData.marketRegion || ""
                }
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                placeholder="Select regions"
              />
              <button
                type="button"
                onClick={() => setIsMarketEditMode(true)}
                className="text-[#bb1ccc] hover:text-[#000080] p-2"
              >
                <Edit size={16} />
              </button>
            </>
          ) : (
            <Select
              isMulti
              name="marketRegion"
              options={regionOptions}
              value={selectedRegions}
              onChange={handleRegionChange}
              className="basic-multi-select w-full"
              classNamePrefix="select"
              placeholder={marketRegionField.placeholder}
              isDisabled={isLoadingCodes || selectedParentRegions.length === 0}
              required={marketRegionField.required}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? "#bb1ccc" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 2px #bb1ccc" : base.boxShadow,
                }),
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const renderMarketCountryField = () => {
    const marketCountryField = formConfig.marketInformation.fields.find(
      (f) => f.name === "marketCountry"
    );

    return (
      <div className="form-group">
        <label>{marketCountryField.label}</label>
        <div className="flex items-center gap-2">
          {!isMarketEditMode ? (
            <>
              <input
                type="text"
                readOnly
                value={
                  Array.isArray(formData.marketCountry)
                    ? formData.marketCountry.join(", ")
                    : formData.marketCountry || ""
                }
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                placeholder="Select countries"
              />
              <button
                type="button"
                onClick={() => setIsMarketEditMode(true)}
                className="text-[#bb1ccc] hover:text-[#000080] p-2"
              >
                <Edit size={16} />
              </button>
            </>
          ) : (
            <Select
              isMulti
              name="marketCountry"
              options={countryOptions}
              value={countryOptions.filter((option) =>
                (formData.marketCountry || []).includes(option.value)
              )}
              onChange={handleCountryChange}
              className="basic-multi-select w-full"
              classNamePrefix="select"
              placeholder={marketCountryField.placeholder}
              isDisabled={selectedRegions.length === 0}
              required={marketCountryField.required}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? "#bb1ccc" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 2px #bb1ccc" : base.boxShadow,
                }),
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const renderLineOfBusinessField = () => {
    const lineOfBusinessField = formConfig.marketInformation.fields.find(
      (f) => f.name === "lineOfBusiness"
    );

    return (
      <div className="form-group">
        <label>{lineOfBusinessField.label}</label>
        <div className="flex items-center gap-2">
          {!isMarketEditMode ? (
            <>
              <input
                type="text"
                readOnly
                value={
                  lineOfBusinessField.options.find(
                    (option) => option.value === formData.lineOfBusiness
                  )?.label || ""
                }
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] bg-white placeholder-gray-500"
                placeholder="Select line of business"
              />
              <button
                type="button"
                onClick={() => setIsMarketEditMode(true)}
                className="text-[#bb1ccc] hover:text-[#000080] p-2"
              >
                <Edit size={16} />
              </button>
            </>
          ) : (
            <Select
              name="lineOfBusiness"
              options={lineOfBusinessField.options}
              value={
                lineOfBusinessField.options.find(
                  (option) => option.value === formData.lineOfBusiness
                ) || null
              }
              onChange={(selectedOption) => {
                setFormData({
                  ...formData,
                  lineOfBusiness: selectedOption ? selectedOption.value : "",
                });
              }}
              className="basic-single-select w-full"
              classNamePrefix="select"
              placeholder={lineOfBusinessField.placeholder}
              isDisabled={isSubmitting}
              required={lineOfBusinessField.required}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: state.isFocused ? "#bb1ccc" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 2px #bb1ccc" : base.boxShadow,
                }),
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const renderSection = (sectionKey, section) => {
    const isOpen = openSections[sectionKey];
    if (sectionKey === "reportInformation") {
      // These must stay OUT of the grid, exactly matched to your config
      const EXCLUDE_FROM_GRID = ["reportType", "reportSections", "reportOwner"];
      const reportTypeField = section.fields.find(f => f.name === "reportType");
      const reportSectionsField = section.fields.find(f => f.name === "reportSections");
      const reportOwnerField = section.fields.find(f => f.name === "reportOwner");
      return (
        <div className="space-y-6" key={sectionKey}>
          <div
            className="inline-flex items-center gap-2 cursor-pointer"
            onClick={() => toggleSection(sectionKey)}
          >
            <ChevronDown
              className={`h-5 w-5 text-[#bb1ccc] mt-[4px] transition-transform ${isOpen ? 'rotate-0' : '-rotate-90'}`}
            />
            <h3 className="text-lg font-bold text-[#bb1ccc] whitespace-nowrap">{section.title}</h3>
          </div>
          {isOpen && (
            <div className="space-y-4 pl-2">
              {/* All other fields in the grid, never render these three */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {section.fields.filter(f => !EXCLUDE_FROM_GRID.includes(f.name)).map((field) => (
                  <div
                    key={field.name}
                    className={field.name === "reportObjective" ? "md:col-span-2" : ""}
                  >
                    <label className="block text-sm font-medium text-gray-700 mb-1">{field.label}</label>
                    {renderField(field)}
                  </div>
                ))}
              </div>

              {(reportTypeField || reportSectionsField) && (
                <div className="flex gap-4 w-full">
                  {reportTypeField && (
                    <div className="w-[30%]">
                      <label className="block text-sm font-medium text-gray-700 mb-1">{reportTypeField.label}</label>
                      {renderField(reportTypeField)}
                    </div>
                  )}
                  {reportSectionsField && (
                    <div className="w-[70%]">
                      <label className="block text-sm font-medium text-gray-700 mb-1">{reportSectionsField.label}</label>
                      <ReportSectionInput
                        field={reportSectionsField}
                        formData={formData}
                        setFormData={setFormData}
                        isSubmitting={isSubmitting}
                      />
                    </div>
                  )}
                </div>
              )}
              {/* {reportOwnerField && (
              <div className="w-[30%] mt-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">{reportOwnerField.label}</label>
                {renderField(reportOwnerField)}
              </div>
            )} */}
              <div className="flex items-center gap-4">
                {reportOwnerField && (
                  <div className="w-[30%] mt-2">
                    {renderReportOwnerField()}
                  </div>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Upload Excel File
                  </label>
                  {!selectedFile ? ( <button
                  type="button"
                    onClick={() => setUploadDialogOpen(true)}
                    onMouseEnter={() => setIsUploadHovered(true)}
                    onMouseLeave={() => setIsUploadHovered(false)}
                    className={`flex items-center space-x-2 px-4 h-[35px] rounded-lg transition-colors duration-200 shadow-md border border-[#bb1ccc] ${isUploadHovered ? "bg-[#bb1ccc] text-white" : "bg-white text-[#bb1ccc]"
                      }`}
                  >
                    <Upload size={18} />
                    <span>Upload Excel</span>
                  </button>) : (
                    <div> <b> {selectedFile?.name || "File Selected"} </b> </div>
                  )}
                 

                </div>

              </div>
            </div>
          )}
        </div>
      );
    }
    return (
      <div className="space-y-6" key={sectionKey}>
        <div
          className="inline-flex items-center gap-2 cursor-pointer"
          onClick={() => toggleSection(sectionKey)}
        >
          <ChevronDown
            className={`h-5 w-5 text-[#bb1ccc] mt-[4px] transition-transform ${isOpen ? 'rotate-0' : '-rotate-90'}`}
          />
          <h3 className="text-lg font-bold text-[#bb1ccc] whitespace-nowrap">{section.title}</h3>
        </div>

        {isOpen && (
          <>
            {section.fields && (

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pl-2">
                {section.fields.map((field) => {
                  if (field.name === "productName") {
                    return (
                      <div key={field.name}>{renderProductNameField()}</div>
                    );
                  }
                  if (field.name === "productCode") {
                    return (
                      <div key={field.name}>{renderProductCodeField()}</div>
                    );
                  }
                  if (field.name === "productOwner") {
                    return (
                      <div key={field.name}>{renderProductOwnerField()}</div>
                    );
                  }
                  if (field.name === "domain") {
                    return <div key={field.name}>{renderDomainField()}</div>;
                  }
                  if (field.name === "subDomain") {
                    return <div key={field.name}>{renderSubdomainField()}</div>;
                  }
                  if (field.name === "subSubDomain") {
                    return <div key={field.name}>{renderSubSubdomainField()}</div>;
                  }
                  if (field.name === "parentRegions") {
                    return (
                      <div key={field.name}>{renderParentRegionField()}</div>
                    );
                  }
                  if (field.name === "marketRegion") {
                    return (
                      <div key={field.name}>{renderMarketRegionField()}</div>
                    );
                  }
                  if (field.name === "marketCountry") {
                    return (
                      <div key={field.name}>{renderMarketCountryField()}</div>
                    );
                  }
                  if (field.name === "lineOfBusiness") {
                    return (
                      <div key={field.name}>{renderLineOfBusinessField()}</div>
                    );
                  }
                  if (field.name === "reportOwner") {
                    return (
                      <div key={field.name}>{renderReportOwnerField()}</div>
                    );
                  }
                  return (
                    <div
                      key={field.name}
                      className={field.name === "description" || field.name === "reportObjective" ? "md:col-span-2" : ""}
                    >
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {field.label}
                      </label>
                      {renderField(field)}
                    </div>
                  );
                })}
              </div>
            )}
            {sectionKey === "costInformation" && (
              <>
                {formConfig.costInformation.costTypes.map((costType) =>
                  renderCostField(costType)
                )}
                {formConfig.costInformation.thresholds && (
                  <div className="mt-6 flex gap-4">
                    {formConfig.costInformation.thresholds.map((threshold) => (
                      <div key={threshold.name} className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          {threshold.label}
                        </label>
                        {renderField(threshold)}
                      </div>
                    ))}
                  </div>
                )}
                <div className="mt-6">
                  <div className="w-1/2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Azure Services Cost (Web App, Logic App)
                    </label>
                    <input
                      type="number"
                      name="azureServicesCost"
                      value={
                        formData.azureServicesCost !== undefined &&
                          formData.azureServicesCost !== null
                          ? formData.azureServicesCost
                          : ""
                      }
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          azureServicesCost:
                            e.target.value === "" ? "" : Number(e.target.value),
                        })
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc]"
                      placeholder="Enter cost in $"
                      required
                      disabled={isSubmitting}
                      min="0"
                    />
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    );
  };

  return (
    <>
    <UploadExcel
        open={uploadDialogOpen}
        onClose={() => setUploadDialogOpen(false)}
        productId={""}
        onUploadSuccess={sethasUploaded}
        productName = {formData?.productName}
        setSelectedFile = {setSelectedFile}
        selectedFile = {selectedFile}
      />
    <div className="space-y-8">
      {Object.entries(formConfig).map(([key, section]) => {
        
        if (key === "reportInformation" && formData.dataLayer !== "analyticalProduct") {
          return null;
        }
        
        return renderSection(key, section);
      })}

    </div>
    
      </>
  );
};

export default OnboardProductFormSections;

